import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269","key":"svg-0"}]]

/**
 * IconCellSignal1
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2VsbC1zaWduYWwtMSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjAgMjBoLTE1LjI2OWEuNzMxIC43MzEgMCAwIDEgLS41MTcgLTEuMjQ5bDE0LjUzNyAtMTQuNTM3YS43MzEgLjczMSAwIDAgMSAxLjI0OSAuNTE3djE1LjI2OSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/cell-signal-1
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCellSignal1 = createReactComponent('outline', 'cell-signal-1', 'CellSignal1', __iconNode);

export default IconCellSignal1;